import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Form, FormCategory, ModalFormCatData, ModalFormData } from '../../../perform-induction/perform-induction';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { FileReaderEvent } from '../../../setup-implement/setup-implement.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  EditForm: boolean;
  Form: Form,
  FormCategory: FormCategory
}

@Component({
  selector: 'app-dialog-edit-details',
  templateUrl: './dialog-edit-details.component.html',
  styleUrls: ['./dialog-edit-details.component.scss']
})
export class DialogEditDetailsComponent implements OnInit {

  constructor(
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<DialogEditDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,
  ) { }

  EditForm: boolean = false;
  Description: string = "";
  Name: string = "";
  Filename: string = "";
  FilePreview: string = "";
  NewFileName: string = "";
  DaysCount:number;
  FormId:number;
  ngOnInit() {
    this.EditForm = this.data.EditForm
    this.Name = this.data.EditForm == true ? this.data.Form.Name : this.data.FormCategory.Name
    this.Description = this.data.EditForm == true ? this.data.Form.Description : this.data.FormCategory.Description
    this.Filename = this.data.EditForm == true ? this.data.Form.Filename : ""
    this.DaysCount = this.data.EditForm == true ? 0 : this.data.FormCategory.DaysCountFilter;
    this.FormId = this.data.EditForm == true ? this.data.Form.ID : 0;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {
    if (this.data.EditForm) {
      let _form = new ModalFormData();
      _form.formName = this.Name;
      _form.formDesc = this.Description;
      _form.categoryID = this.data.Form.FormCategoryID;
      _form.formID = this.FormId;

      if (this.FilePreview) {
        _form.fileName = this.NewFileName
        var sImageUrl = this.FilePreview.replace(/^data:image\/[a-z]+;base64,/, "");
        sImageUrl = this.FilePreview.replace(/^data:image\/\w+;base64,/, "");
        _form.formData = this.FilePreview
      }
      this._inductionService.CreateForm(_form).subscribe(res => {
        if (res) {
          this.dialogRef.close(true);
        }
      })


    } else {
      let params = new ModalFormCatData();
      params.categoryName = this.Name;
      params.categoryDesc = this.Description;
      params.categoryID = this.data.FormCategory.ID;
      params.requireIncidentNo = this.data.FormCategory.RequireIncidentNo;
      params.days =this.DaysCount;


      this._inductionService.UpdateFormCategory(params).subscribe(res => {
        if (res) {
          this.dialogRef.close(true);
        }
      })
    }

  }

  onFileChanged(event) {


    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

console.log("event.target.files[0]",event.target.files[0])
      this.NewFileName = event.target.files[0].name
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        var fileUrl = (event.target["result"]);
        this.FilePreview = fileUrl;
      }
    }

  }

}
